import api from "@/api/api";
import request from "@/utils/request";

export const changePassword = (data: API.ChangePasswordReq): Promise<API.ChangePasswordRes> => {
  return request.post(api.system_passwordChange, data);
};
